import React, { ReactNode, useEffect, useState } from 'react';
import { User } from './models/user.model';

export type UtilsProps = {
  /**
   * a node to be rendered in the special component.
   */
  children?: ReactNode;
};

export const getUser = (
  userId: number | null,
  users: User[]
): User | null | undefined => {
  if (userId) {
    return users.find((user) => user.id === userId);
  }
  return null;
};

export const useDebounce = <T,>(value: T, delay = 500): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
};
